export default "__VITE_ASSET__UVijCXN4__"